/* dcb-quickadd.js v2.7 (2026-09-15: package-savings line; v2.6 2026-09-10) — DC Bundles configurator for the
   quick-add drawer. Fetches /products/<handle>?section_id=dcb-quickadd-data
   when the drawer shows a bundle and renders every slot as a "Choose your …"
   section of product cards (image, title, inline color/option dropdown,
   the option's own price — no deltas). Swap slots drive the theme's real
   variant options underneath (price, availability and the cart variant stay
   the theme's); the size dimension is one dropdown in its slot header with
   a size-chart link; removable slots carry an Include checkbox. Writes the
   SAME cart-line properties the cart transform reads (_dcb_cN =
   "Choice[ :: Color]" / same-price pick label, _dcb_skip = "2,3"); defaults
   write nothing, so any failure leaves the stock drawer untouched.
   v2.6 (Dany 2026-09-10): when every item but ONE is unticked, the add
   carts that item's OWN variant (no bundle wrapper) so cart, checkout,
   order page and emails all show the real product name and image; a
   hidden _dcb_parent property keeps order attribution. Any selection the
   map cannot resolve to a variant id falls back to the bundle path. */
(function () {
  'use strict';
  if (window.__dcbQuickAdd) return;
  window.__dcbQuickAdd = true;

  var cache = {};   // productUrl -> data | null
  var state = {};   // productUrl -> { pick:{attr|handle:label}, alt:{attr:label}, altColor:{attr|label:color}, skip:{pos:true}, focus:pos }

  function drawer() { return document.querySelector('quick-add-drawer'); }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function baseUrl(u) { return (u || '').split('?')[0].split('#')[0]; }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  }

  function cartForm(d) {
    var forms = d.querySelectorAll('.js-footer-content form[action*="/cart/add"], form.js-product-form');
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].classList.contains('js-instalments-form')) return forms[i];
    }
    return null;
  }
  function currentVariantId(d) {
    var f = cartForm(d);
    var inp = f && f.querySelector('input[name="id"], select[name="id"]');
    if (inp && inp.value) return String(inp.value);
    var any = d.querySelector('input[name="id"]');
    return any ? String(any.value) : null;
  }
  function st(url) {
    var k = baseUrl(url);
    if (!state[k]) state[k] = { pick: {}, alt: {}, altColor: {}, skip: {}, focus: null };
    return state[k];
  }

  /* ------------------------------------------------------------ data */
  function load(url, cb) {
    var key = baseUrl(url);
    if (key in cache) { cb(cache[key]); return; }
    fetch(key + '?section_id=dcb-quickadd-data', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var data = null;
        try {
          var m = html.match(/<script[^>]*data-dcb-qa[^>]*>([\s\S]*?)<\/script>/);
          if (m) data = JSON.parse(m[1]);
        } catch (e) { data = null; }
        if (!data || !data.bundle || !data.map) data = null;
        else index(data);
        cache[key] = data;
        cb(data);
      })
      .catch(function () { cache[key] = null; cb(null); });
  }

  function isAlt(c) {
    return !!(c && c.alt) || !!(c && c.attr && Array.isArray(c.choices) && c.choices.some(function (ch) {
      return ch && (typeof ch.price_cents === 'number' || ch.handle);
    }));
  }
  function nounOf(c, fallback) {
    var l = (c && c.attr_label) || '';
    if (l && !/^(options?|choices?|alternative)$/i.test(l.trim()) && !/colou?r$/i.test(l.trim())) return l;
    var ch = (c && c.choices || []).find(function (x) { return x && x.opt_label; });
    if (ch) { var n = ch.opt_label.replace(/\s*colou?r$/i, ''); if (n) return n; }
    if (/colou?r$/i.test(l)) { var n2 = l.replace(/\s*colou?r$/i, ''); if (n2) return n2; }
    var m = /(snorkel|mask|fins?|boots?|gloves?|regulator|octopus|computer|bcd|wetsuit)/i.exec((c && c.title) || '');
    return m ? m[1].charAt(0).toUpperCase() + m[1].slice(1) : (fallback || 'Item');
  }

  /* Build: variant index, entry index, and per-dimension info. A swap
     dimension "owns" the component position whose title is constant per
     value and differs between values (option values are Shopify-truncated,
     the map carries the full product). */
  function index(data) {
    data.byId = {};
    (data.variants || []).forEach(function (v) { data.byId[String(v.id)] = v; });
    data.entryById = {};
    var entries = [];
    var names = data.optnames || [];
    Object.keys(data.map).forEach(function (k) {
      var e = data.map[k];
      var id = e && e.parent_variant_gid ? String(e.parent_variant_gid).split('/').pop() : null;
      if (!id) return;
      // 2026-09-23: option values can be RENAMED in Shopify (productOptionUpdate
      // keeps variant ids). The live variant's options are the truth for
      // matching; the map's selections strings are only a fallback when the
      // parent variant is not in this product's variant list.
      var lv = data.byId[id];
      if (lv && Array.isArray(lv.options) && names.length) {
        var live = {};
        names.forEach(function (n, i) { if (lv.options[i] !== undefined && lv.options[i] !== null) live[n] = lv.options[i]; });
        e.selections = Object.assign({}, e.selections || {}, live);
      }
      data.entryById[id] = e; entries.push(e);
    });
    data.entries = entries;
    var positions = {};
    entries.forEach(function (e) { (e.components || []).forEach(function (c) { positions[c.position] = true; }); });
    data.dims = names.map(function (opt, di) {
      var dim = { index: di, name: opt, kind: /size/i.test(opt) ? 'size' : 'swap', pos: null, values: [] };
      var seen = {};
      entries.forEach(function (e) {
        var v = e.selections && e.selections[opt];
        if (v !== undefined && !seen[String(v).trim()]) { seen[String(v).trim()] = true; dim.values.push({ value: String(v).trim(), raw: v }); }
      });
      if (dim.kind === 'swap') {
        Object.keys(positions).some(function (p) {
          var byVal = {}, ok = true;
          entries.forEach(function (e) {
            var val = e.selections && e.selections[opt];
            var c = (e.components || []).find(function (x) { return String(x.position) === String(p); });
            if (val === undefined || !c || !c.title) return;
            val = String(val).trim();
            if (byVal[val] && byVal[val].title !== c.title) ok = false;
            if (!byVal[val]) byVal[val] = c;
          });
          var vals = Object.keys(byVal), titles = {};
          vals.forEach(function (v) { titles[byVal[v].title] = true; });
          if (ok && vals.length > 1 && Object.keys(titles).length === vals.length) {
            dim.pos = p;
            dim.values.forEach(function (o) { o.comp = byVal[o.value] || null; });
            return true;
          }
          return false;
        });
        if (dim.pos === null) dim.kind = 'other';
      }
      return dim;
    });
    // size dim attaches to the swap dim sharing a word ("Fin Size" -> "Fins"),
    // else to the highest-position swap dim
    data.dims.forEach(function (sd) {
      if (sd.kind !== 'size') return;
      var word = sd.name.replace(/size/i, '').trim().toLowerCase().replace(/s$/, '');
      var host = data.dims.find(function (d2) { return d2.kind === 'swap' && word && d2.name.toLowerCase().replace(/s$/, '') === word; });
      if (!host) host = data.dims.filter(function (d2) { return d2.kind === 'swap'; }).sort(function (a, b) { return b.pos - a.pos; })[0];
      sd.values = sortSizes(sd.values);
      if (host) host.sizeDim = sd;
    });
  }

  var SIZE_ORDER = ['2XS', 'XXS', 'XS', 'S', 'SM', 'M', 'MD', 'ML', 'REG', 'L', 'LG', 'XL', '2XL', 'XXL'];
  function sizeKey(v) {
    var m = /^\s*(\d+(?:\.\d+)?)/.exec(v);
    if (m) return [1, parseFloat(m[1]), v];
    var up = String(v).toUpperCase();
    for (var i = 0; i < SIZE_ORDER.length; i++) {
      if (up === SIZE_ORDER[i] || up.indexOf(SIZE_ORDER[i] + ' ') === 0 || up.indexOf(SIZE_ORDER[i] + '/') === 0 || up.indexOf(SIZE_ORDER[i] + '(') === 0) return [0, i, v];
    }
    return [2, 0, v];
  }
  function sortSizes(vals) {
    return vals.slice().sort(function (a, b) {
      var ka = sizeKey(a.value), kb = sizeKey(b.value);
      return ka[0] - kb[0] || ka[1] - kb[1] || (ka[2] < kb[2] ? -1 : ka[2] > kb[2] ? 1 : 0);
    });
  }

  function variantFor(data, sel) {
    return (data.variants || []).find(function (v) {
      return v.options.every(function (o, i) { return String(o).trim() === String(sel[i]).trim(); });
    }) || null;
  }

  /* ---------------------------------------------- theme picker driving */
  function holdAdd(d) {
    var btn = d.querySelector('.js-footer-content button[name="add"], form.js-product-form button[name="add"]');
    if (!btn || btn.hasAttribute('data-dcb-hold')) return;
    btn.setAttribute('data-dcb-hold', '1');
    btn.disabled = true;
    var release = function () {
      btn.disabled = false; btn.removeAttribute('data-dcb-hold');
      document.removeEventListener('on:variant:change', release, true);
    };
    document.addEventListener('on:variant:change', release, true);
    setTimeout(release, 2000);
  }

  function applyProduct(d, data, swapDim, raw, cur) {
    holdAdd(d);
    var probe = cur.options.slice(); probe[swapDim.index] = raw;
    var probeV = variantFor(data, probe);
    // jump to this product's first AVAILABLE size when the current size does
    // not exist or is sold out for it (2026-08-26: TUSA XS default)
    if ((!probeV || !probeV.available) && swapDim.sizeDim) {
      var sd = swapDim.sizeDim, best = null;
      sd.values.forEach(function (o) {
        var p2 = probe.slice(); p2[sd.index] = o.raw;
        var v = variantFor(data, p2);
        if (v && (!best || (v.available && !best.available))) best = { v: v, raw: o.raw };
      });
      if (best) {
        // the theme's picker resolves one change per tick: apply the size,
        // let it settle, THEN switch the product (same-tick clicks left the
        // variant on the stale size -- seen live 2026-08-26)
        applyOption(d, sd.index, best.raw);
        setTimeout(function () { applyOption(d, swapDim.index, raw); }, 400);
        return;
      }
    }
    applyOption(d, swapDim.index, raw);
  }

  function applyOption(d, di, value) {
    var scope = d.querySelector('.option-selector[data-index="' + (di + 1) + '"]');
    if (!scope) return false;
    var done = false;
    scope.querySelectorAll('input[type=radio]').forEach(function (r) {
      if (done || String(r.value).trim() !== String(value).trim()) return;
      if (!r.checked) r.click();
      done = true;
    });
    if (!done) scope.querySelectorAll('select').forEach(function (s) {
      if (done) return;
      for (var i = 0; i < s.options.length; i++) {
        if (String(s.options[i].value).trim() === String(value).trim()) {
          if (s.selectedIndex !== i) { s.selectedIndex = i; s.dispatchEvent(new Event('change', { bubbles: true })); }
          done = true; break;
        }
      }
    });
    if (!done) scope.querySelectorAll('.custom-select__option').forEach(function (o) {
      if (done) return;
      if (String(o.getAttribute('data-value') || '').trim() === String(value).trim()) {
        var cs = o.closest('custom-select');
        if (cs && cs.selectOption) cs.selectOption(o);
        done = true;
      }
    });
    return done;
  }

  /* ----------------------------------------------------- properties */
  function pickFor(c, s) {
    if (!c.attr || !Array.isArray(c.choices) || !c.choices.length) return null;
    var label = s.pick[c.attr + '|' + (c.handle || '')];
    return (label && c.choices.find(function (x) { return x && x.label === label; })) || c.choices[0];
  }
  function altChoice(c, s) {
    var label = s.alt[c.attr];
    return (label && c.choices.find(function (x) { return x && x.label === label; })) || c.choices[0];
  }
  function altColor(c, ch, s) {
    if (!ch || !Array.isArray(ch.variants) || ch.variants.length < 2) return null;
    var def = ch.variants.find(function (v) { return v && v['default']; }) || ch.variants[0];
    var memo = s.altColor[c.attr + '|' + ch.label];
    var pick = memo ? ch.variants.find(function (v) { return v && v.label === memo; }) : null;
    return { list: ch.variants, chosen: pick || def, def: def, isDefault: !pick || pick.label === def.label };
  }

  function numId(gid) {
    var m = /(\d+)\s*$/.exec(String(gid || ''));
    return m ? m[1] : null;
  }
  /* v2.6: the solo direct-add — exactly one component kept => resolve the
     shopper's actual selection (same-price pick / alt / alt color) to that
     product's own variant id + the item's own price. null = not solo, or
     the selection has no variant id in the map (bundle path then). */
  function soloDirect(entry, s) {
    if (!entry || !Array.isArray(entry.components) || entry.components.length < 2) return null;
    var kept = entry.components.filter(function (c) {
      return !(c && c.removable && s.skip[c.position]);
    });
    if (kept.length !== 1) return null;
    var c = kept[0];
    var gid = c.variant_gid;
    var price = typeof c.price_cents === 'number' ? c.price_cents : null;
    if (c.attr && Array.isArray(c.choices) && c.choices.length) {
      if (isAlt(c)) {
        var ch = altChoice(c, s);
        if (!ch) return null;
        if (typeof ch.price_cents === 'number') price = ch.price_cents;
        gid = ch.variant_gid || null;
        var col = altColor(c, ch, s);
        if (col && !col.isDefault) gid = col.chosen && (col.chosen.variant_gid || col.chosen.id) || null;
      } else {
        var pk = pickFor(c, s);
        if (pk && pk !== c.choices[0]) gid = pk.variant_gid || null;
      }
    }
    var id = numId(gid);
    if (!id) return null;
    return { id: id, qty: c.qty || 1, price: price };
  }

  function writeProps(d, data, url, atSubmit) {
    var f = cartForm(d);
    if (!f) return;
    var vid = currentVariantId(d);
    // v2.6: a second submit-path call sees the already-swapped solo id --
    // resolve the bundle entry from the remembered original so the pass
    // is idempotent instead of stripping the _dcb_parent property
    var soloOrig = f.querySelector('input[name="id"][data-dcb-solo-orig], select[name="id"][data-dcb-solo-orig]');
    if (soloOrig) vid = soloOrig.getAttribute('data-dcb-solo-orig');
    var entry = vid && data.entryById[vid];
    var s = st(url);
    var wanted = {};
    if (entry) {
      (entry.components || []).forEach(function (c) {
        if (!c || !c.attr || !Array.isArray(c.choices) || !c.choices.length) return;
        var val = null;
        if (isAlt(c)) {
          var ch = altChoice(c, s), col = altColor(c, ch, s);
          if (col && !col.isDefault) val = ch.label + ' :: ' + col.chosen.label;
          else if (ch !== c.choices[0]) val = ch.label;
        } else {
          var pk = pickFor(c, s);
          if (pk && pk !== c.choices[0]) val = pk.label;
        }
        if (val) wanted[c.attr] = val;
      });
      var skip = Object.keys(s.skip).filter(function (p) {
        return s.skip[p] && (entry.components || []).some(function (c) { return c && c.removable && String(c.position) === String(p); });
      }).sort();
      if (skip.length) wanted['_dcb_skip'] = skip.join(',');
    }
    f.querySelectorAll('input[data-dcb-qa-prop]').forEach(function (i) {
      if (!(i.getAttribute('data-dcb-qa-prop') in wanted)) i.remove();
    });
    Object.keys(wanted).forEach(function (attr) {
      var name = 'properties[' + attr + ']';
      var input = f.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden'; input.name = name;
        input.setAttribute('data-dcb-qa-prop', attr);
        f.appendChild(input);
      }
      input.value = wanted[attr];
    });
    // v2.6 solo direct-add: swap the form onto the kept item's own variant
    // at SUBMIT time only; any render after an aborted submit restores it.
    var idInput = f.querySelector('input[name="id"], select[name="id"]');
    if (idInput && idInput.hasAttribute('data-dcb-solo-orig') && !atSubmit) {
      idInput.value = idInput.getAttribute('data-dcb-solo-orig');
      idInput.removeAttribute('data-dcb-solo-orig');
    }
    if (atSubmit && entry && idInput) {
      var solo = soloDirect(entry, s);
      if (solo) {
        f.querySelectorAll('input[data-dcb-qa-prop]').forEach(function (i) { i.remove(); });
        var pin = document.createElement('input');
        pin.type = 'hidden'; pin.name = 'properties[_dcb_parent]';
        pin.setAttribute('data-dcb-qa-prop', '_dcb_parent');
        pin.value = 'gid://shopify/ProductVariant/' + vid;
        f.appendChild(pin);
        if (!idInput.hasAttribute('data-dcb-solo-orig')) idInput.setAttribute('data-dcb-solo-orig', idInput.value);
        idInput.value = solo.id;
        if (solo.qty > 1) {
          var qin = f.querySelector('input[name="quantity"], select[name="quantity"]');
          if (qin) qin.value = String((parseInt(qin.value, 10) || 1) * solo.qty);
          else {
            var qi = document.createElement('input');
            qi.type = 'hidden'; qi.name = 'quantity'; qi.value = String(solo.qty);
            qi.setAttribute('data-dcb-qa-prop', '_dcb_solo_qty');
            f.appendChild(qi);
          }
        }
      }
    }
  }

  function paintPrice(d, data, url) {
    var vid = currentVariantId(d);
    var v = vid && data.byId[vid];
    var entry = vid && data.entryById[vid];
    if (!v) return;
    var total = v.price, s = st(url);
    var solo = entry && soloDirect(entry, s);
    if (solo && typeof solo.price === 'number') {
      // v2.6: a solo config is carted as the item itself, at its own price
      total = solo.price * solo.qty;
    } else if (entry) {
      (entry.components || []).forEach(function (c) {
        if (c && c.removable && s.skip[c.position]) {
          total -= Math.round((parseFloat(c.alloc || '0') || 0) * 100);
          return;
        }
        if (isAlt(c) && Array.isArray(c.choices) && c.choices.length) {
          var ch = altChoice(c, s), base = c.choices[0];
          if (typeof ch.price_cents === 'number' && typeof base.price_cents === 'number') total += ch.price_cents - base.price_cents;
        }
      });
    }
    var pel = d.querySelector('.product-info__price .price__current .js-value, .price__current .js-value');
    if (pel) pel.textContent = money(Math.max(0, total));
    paintPackageSavings(d, data, Math.max(0, total), pel);
  }

  /* v2.7: package savings (dc_bundles.package_savings on the parent). The
     listing is SUM (MAP) priced; the dc-bundle-savings Discount Function
     takes `percent` off every line that came from this bundle in the cart,
     whatever the shopper configured -- so the drawer shows the package price
     the shopper will actually pay, right under the theme's price. */
  function paintPackageSavings(d, data, total, pel) {
    var s = data && data.savings;
    var old = d.querySelector('.dcb-qa__pkg');
    var pct = s && Number(s.percent);
    if (!(pct > 0 && pct <= 100) || !(total > 0) || !pel) { if (old) old.remove(); return; }
    var priceBox = pel.closest('.price') || pel.closest('.product-info__price') || pel.parentNode;
    if (!priceBox || !priceBox.parentNode) return;
    var off = Math.round(total * pct / 100), pctDisp = Math.round(pct);
    var msg = typeof s.message === 'string' && s.message ? s.message : 'Package Savings';
    var box = old || el('div', 'dcb-qa__pkg');
    box.setAttribute('style', 'margin:6px 0 10px;padding:8px 10px;border:2px solid #cb1836;border-radius:6px;background:#fff5f6;font-size:14px;line-height:1.4;');
    while (box.firstChild) box.removeChild(box.firstChild);
    var pill = el('span', '', msg + ': ' + pctDisp + '% off');
    pill.setAttribute('style', 'display:inline-block;padding:3px 8px;border-radius:4px;background:#cb1836;color:#fff;font-weight:700;font-size:12px;margin-bottom:4px;');
    box.appendChild(pill);
    var line = el('div', '');
    line.appendChild(el('span', '', 'Package price '));
    var strong = el('strong', '', money(total - off));
    strong.setAttribute('style', 'color:#cb1836;font-size:17px;');
    line.appendChild(strong);
    var was = el('s', '', money(total));
    was.setAttribute('style', 'color:#565959;margin-left:8px;');
    line.appendChild(was);
    line.appendChild(el('span', '', '  You save ' + money(off)));
    box.appendChild(line);
    var note = el('div', '', pctDisp + '% package discount applied automatically in cart, on any configuration of this package.');
    note.setAttribute('style', 'font-size:12px;color:#333;margin-top:3px;');
    box.appendChild(note);
    if (!old) priceBox.parentNode.insertBefore(box, priceBox.nextSibling);
  }

  /* -------------------------------------------------------- main image */
  function sized(src, w) {
    if (!src) return src;
    return /[?&]width=/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w)
      : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function setMainImage(d, src, alt) {
    var box = d.querySelector('.quick-add-info__media');
    if (!box || !src) return;
    var img = box.querySelector('img');
    if (!img) { img = document.createElement('img'); box.appendChild(img); }
    var w = box.offsetWidth || 144;
    img.src = sized(src, w * 2);
    img.srcset = sized(src, w) + ' 1x, ' + sized(src, w * 2) + ' 2x';
    img.alt = alt || '';
  }

  /* ---------------------------------------------------------- size chart */
  function openChart(d, chart) {
    closeChart(d);
    var wrap = el('div', 'dcb-qa__modal');
    var box = el('div', 'dcb-qa__modal-box');
    var head = el('div', 'dcb-qa__modal-head');
    head.appendChild(el('span', 'dcb-qa__modal-title', chart.title || 'Size chart'));
    var x = el('button', 'dcb-qa__modal-close', '×');
    x.type = 'button'; x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', function () { closeChart(d); });
    head.appendChild(x);
    box.appendChild(head);
    var body = el('div', 'dcb-qa__modal-body rte');
    body.innerHTML = chart.content || '';
    box.appendChild(body);
    wrap.appendChild(box);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) closeChart(d); });
    (d.querySelector('.drawer__content') || d).appendChild(wrap);
  }
  function closeChart(d) {
    var m = d.querySelector('.dcb-qa__modal');
    if (m) m.remove();
  }

  /* ---------------------------------------------------------------- UI */
  function colorSelect(list, current, onPick) {
    var sel = el('select', 'dcb-qa__color');
    list.forEach(function (x) {
      if (!x || !x.label) return;
      var o = document.createElement('option');
      o.value = x.label; o.textContent = x.label;
      if (x.label === current) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('click', function (e) { e.stopPropagation(); });
    sel.addEventListener('change', function () { onPick(sel.value); });
    return sel;
  }

  function card(opts) {
    var lab = el('label', 'dcb-qa__opt' + (opts.on ? ' is-on' : '') + (opts.soldout ? ' is-soldout' : ''));
    var r = document.createElement('input');
    r.type = 'radio'; r.name = opts.group; r.checked = !!opts.on;
    r.addEventListener('change', function () { if (r.checked) opts.onSelect(); });
    lab.appendChild(r);
    if (opts.image) { var im = document.createElement('img'); im.src = opts.image; im.alt = ''; lab.appendChild(im); }
    var mid = el('span', 'dcb-qa__opt-mid');
    mid.appendChild(el('span', 'dcb-qa__opt-title', opts.title));
    // Jason 2026-09-22: component SKU on every card; follows the colour pick
    var skuEl = el('span', 'dcb-qa__opt-sku', opts.sku ? 'SKU ' + opts.sku : '');
    mid.appendChild(skuEl);
    var setSku = function (v) {
      var hit = (opts.colorList || []).find(function (x) { return x && x.label === v; });
      var sku = (hit && hit.sku) || opts.sku || '';
      skuEl.textContent = sku ? 'SKU ' + sku : '';
    };
    if (opts.soldout) mid.appendChild(el('span', 'dcb-qa__opt-soldout', 'Sold out in this size'));
    if (opts.nosize) mid.appendChild(el('span', 'dcb-qa__opt-note', 'Different size range \u2014 pick to see its sizes'));
    lab.appendChild(mid);
    if (opts.colorList && opts.colorList.length > 1) {
      var cs = colorSelect(opts.colorList, opts.colorCurrent, function (v) { setSku(v); opts.onColor(v); });
      var cwrap = el('span', 'dcb-qa__opt-color');
      cwrap.appendChild(cs);
      lab.appendChild(cwrap);
    }
    if (typeof opts.price === 'number') lab.appendChild(el('span', 'dcb-qa__opt-price', money(opts.price)));
    return lab;
  }

  function render(d, data, url) {
    var host = d.querySelector('.js-product-details');
    if (!host) return;
    var old = host.querySelector('.dcb-qa');
    var vid = currentVariantId(d);
    var entry = vid && data.entryById[vid];
    var cur = vid && data.byId[vid];
    if (!entry || !cur) { if (old) old.remove(); host.classList.remove('dcb-qa-active'); writeProps(d, data, url); return; }
    var s = st(url);
    var box = el('div', 'dcb-qa');
    var comps = (entry.components || []).slice().sort(function (a, b) { return a.position - b.position; });

    comps.forEach(function (c) {
      var swapDim = data.dims.find(function (dm) { return dm.kind === 'swap' && String(dm.pos) === String(c.position); });
      // sold-out removable (Linh 2026-11-03): locked off, see dcb-oos-swap.js
      var altPickQa = (c.removable && c.oos === true && isAlt(c)) ? altChoice(c, s) : null;
      var forcedOff = c.removable && c.oos === true
        && !(altPickQa && c.choices[0] && altPickQa.label !== c.choices[0].label);
      if (forcedOff) s.skip[c.position] = true;
      var sec = el('div', 'dcb-qa__section' + (s.skip[c.position] ? ' is-off' : ''));
      var head = el('div', 'dcb-qa__section-head');
      var noun = swapDim ? swapDim.name : nounOf(c, 'Item ' + c.position);
      head.appendChild(el('span', 'dcb-qa__head', 'Choose your ' + noun.toLowerCase()));
      var tools = el('span', 'dcb-qa__tools');

      // size dropdown (+ size chart) lives in the slot header
      if (swapDim && swapDim.sizeDim) {
        var sd = swapDim.sizeDim;
        var slab = el('label', 'dcb-qa__size');
        slab.appendChild(document.createTextNode('Size:'));
        var ssel = el('select', 'dcb-qa__size-select');
        sd.values.forEach(function (o) {
          var probe = cur.options.slice(); probe[sd.index] = o.raw;
          var pv = variantFor(data, probe);
          if (!pv) return;                      // this product has no such size
          var opt = document.createElement('option');
          opt.value = o.value;
          opt.textContent = o.value + (pv.available ? '' : ' (sold out)');
          if (String(cur.options[sd.index]).trim() === o.value) opt.selected = true;
          ssel.appendChild(opt);
        });
        ssel.addEventListener('change', function () { s.focus = c.position; holdAdd(d); applyOption(d, sd.index, ssel.value); });
        slab.appendChild(ssel);
        tools.appendChild(slab);
        var chart = data.size_charts && data.size_charts[c.handle];
        if (chart) {
          var a = el('a', 'dcb-qa__chart', 'Size chart');
          a.href = chart.url || '#';
          a.addEventListener('click', function (e) { e.preventDefault(); openChart(d, chart); });
          tools.appendChild(a);
        }
      }
      if (c.removable) {
        var ilab = el('label', 'dcb-qa__include');
        var cb = document.createElement('input');
        cb.type = 'checkbox'; cb.checked = !s.skip[c.position];
        if (forcedOff) cb.disabled = true;
        cb.addEventListener('change', function () { s.skip[c.position] = !cb.checked; refresh(d, data, url); });
        ilab.appendChild(cb);
        ilab.appendChild(document.createTextNode(forcedOff ? 'Sold out' : 'Include'));
        tools.appendChild(ilab);
      }
      head.appendChild(tools);
      sec.appendChild(head);

      var group = 'dcb-qa-' + c.position;
      if (swapDim) {
        // product cards = the theme's option values, driven onto the native picker
        swapDim.values.forEach(function (o) {
          var isOn = String(cur.options[swapDim.index]).trim() === o.value;
          var rc = isOn ? c : (o.comp || {});          // current slot data wins
          var probe = cur.options.slice(); probe[swapDim.index] = o.raw;
          var pv = variantFor(data, probe);
          var colors = (rc.attr && Array.isArray(rc.choices)) ? rc.choices : [];
          var pk = colors.length ? (s.pick[rc.attr + '|' + (rc.handle || '')] || colors[0].label) : null;
          var pkObj = colors.find(function (x) { return x && x.label === pk; }) || colors[0];
          sec.appendChild(card({
            group: group, on: isOn,
            image: (pkObj && pkObj.image) || rc.image || null,
            title: rc.title || o.value,
            sku: (pkObj && pkObj.sku) || rc.sku || '',
            price: typeof rc.price_cents === 'number' ? rc.price_cents : null,
            soldout: !!(pv && !pv.available),
            nosize: !pv,
            colorList: colors, colorCurrent: pk,
            onColor: function (v) {
              s.pick[rc.attr + '|' + (rc.handle || '')] = v;
              s.focus = c.position;
              if (isOn) refresh(d, data, url); else applyProduct(d, data, swapDim, o.raw, cur);
            },
            onSelect: function () { s.focus = c.position; applyProduct(d, data, swapDim, o.raw, cur); }
          }));
        });
      } else if (isAlt(c) && Array.isArray(c.choices) && c.choices.length) {
        var curAlt = altChoice(c, s);
        c.choices.forEach(function (x) {
          if (!x || !x.label) return;
          var col = altColor(c, x, s);
          sec.appendChild(card({
            group: group, on: x === curAlt,
            image: (col && col.chosen.image) || x.image || null,
            title: x.title || x.label,
            sku: (col && col.chosen && col.chosen.sku) || x.sku || '',
            price: typeof x.price_cents === 'number' ? x.price_cents : null,
            colorList: col ? col.list : [], colorCurrent: col ? col.chosen.label : null,
            onColor: function (v) { s.altColor[c.attr + '|' + x.label] = v; s.alt[c.attr] = x.label; s.focus = c.position; refresh(d, data, url); },
            onSelect: function () { s.alt[c.attr] = x.label; s.focus = c.position; refresh(d, data, url); }
          }));
        });
      } else {
        // fixed component: one card, color dropdown if it has same-price picks
        var colors2 = (c.attr && Array.isArray(c.choices)) ? c.choices : [];
        var pk2 = colors2.length ? (s.pick[c.attr + '|' + (c.handle || '')] || colors2[0].label) : null;
        var pk2Obj = colors2.find(function (x) { return x && x.label === pk2; }) || colors2[0];
        head.querySelector('.dcb-qa__head').textContent = noun;
        sec.appendChild(card({
          group: group, on: true,
          image: (pk2Obj && pk2Obj.image) || c.image || null,
          title: c.title || ('Item ' + c.position),
          sku: (pk2Obj && pk2Obj.sku) || c.sku || '',
          price: typeof c.price_cents === 'number' ? c.price_cents : null,
          colorList: colors2, colorCurrent: pk2,
          onColor: function (v) { s.pick[c.attr + '|' + (c.handle || '')] = v; s.focus = c.position; refresh(d, data, url); },
          onSelect: function () {}
        }));
      }
      box.appendChild(sec);
    });

    var note = el('p', 'dcb-qa__note');
    var a2 = el('a', null, 'Open the full configurator');
    a2.href = baseUrl(url);
    note.appendChild(a2);
    note.appendChild(document.createTextNode(' for specs and side-by-side comparisons.'));
    box.appendChild(note);

    var anchor = host.querySelector('.product-options');
    if (old) old.replaceWith(box);
    else if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling);
    else host.appendChild(box);
    host.classList.add('dcb-qa-active');

    writeProps(d, data, url);
    paintPrice(d, data, url);
    if (s.focus) {
      var fc = comps.find(function (c) { return String(c.position) === String(s.focus); });
      if (fc) {
        var src = null;
        if (isAlt(fc)) { var ac = altChoice(fc, s), acol = altColor(fc, ac, s); src = (acol && acol.chosen.image) || ac.image; }
        else { var fp = pickFor(fc, s); src = (fp && fp.image) || fc.image; }
        setMainImage(d, src || fc.image, fc.title || '');
      }
    }
  }
  function refresh(d, data, url) { render(d, data, url); }

  /* ------------------------------------------------------------ wiring */
  var lastUrl = null;
  function tick() {
    var d = drawer();
    if (!d || !d.productUrl) return;
    var url = d.productUrl;
    var host = d.querySelector('.js-product-details');
    if (!host || !host.querySelector('.product-options, form')) return;
    if (d.classList.contains('is-loading')) return;
    load(url, function (data) {
      if (!data) { var old = host.querySelector('.dcb-qa'); if (old) old.remove(); host.classList.remove('dcb-qa-active'); return; }
      if (!host.querySelector('.dcb-qa') || lastUrl !== url) { lastUrl = url; render(d, data, url); }
      else writeProps(d, data, url);
    });
  }
  var queued = false;
  function schedule() {
    if (queued) return; queued = true;
    setTimeout(function () { queued = false; tick(); }, 60);
  }
  document.addEventListener('on:variant:change', function (e) {
    var d = drawer();
    if (!d || !d.contains(e.target)) return;
    setTimeout(function () {
      var data = cache[baseUrl(d.productUrl)];
      if (data) render(d, data, d.productUrl);
    }, 120);
  }, true);
  document.addEventListener('submit', function (e) {
    var d = drawer();
    if (!d || !e.target || !d.contains(e.target)) return;
    var data = cache[baseUrl(d.productUrl)];
    if (data) writeProps(d, data, d.productUrl, true);
  }, true);
  document.addEventListener('click', function (e) {
    var d = drawer();
    if (!d || !e.target || !e.target.closest) return;
    var btn = e.target.closest('button[name="add"]');
    if (!btn || !d.contains(btn)) return;
    var data = cache[baseUrl(d.productUrl)];
    if (data) writeProps(d, data, d.productUrl, true);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var d = drawer(); if (d) closeChart(d); } });
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.closest && t.closest('.dcb-qa, .dcb-qa__modal')) continue;
      var d = drawer();
      if (d && t && d.contains(t)) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden'] });
  schedule();
})();
